import React, { useState } from 'react';
import { db } from '../../firebaseConfig';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { useTranslation } from 'react-i18next';
import './ManageClinics.css'; // reuse styles
import BackToClinicDashboard from '../BackToClinicDashboard';

const RegisterCustomer = () => {
  const { t } = useTranslation();
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    address: '',
    phone: '',
  });
  
  const [token, setToken,] = useState('');
  

  const generateToken = () => {
    return 'cust-' + Math.random().toString(36).substring(2, 10);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newToken = generateToken();
    try {
      await addDoc(collection(db, 'customers'), {
        ...formData,
        token: newToken,
        created_at: Timestamp.now(),
        type: 'clinic',
      });
      setToken(newToken);
      setFormData({ name: '', email: '', address: '', phone: '' });
    } catch (err) {
      console.error('Failed to register customer:', err);
    }
  };

  return (
    <div className="manage-clinics-container">
      <h2 className="manage-clinics-title">{t('registerCustomer.title')}</h2>
      <BackToClinicDashboard token={token} />
      <form onSubmit={handleSubmit} className="manage-clinics-form">
        <input
          placeholder={t('registerCustomer.name')}
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />
        <input
          placeholder={t('registerCustomer.email')}
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        />
        <input
          placeholder={t('registerCustomer.address')}
          value={formData.address}
          onChange={(e) => setFormData({ ...formData, address: e.target.value })}
        />
        <input
          placeholder={t('registerCustomer.phone')}
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
        />
        <button type="submit" className="manage-clinics-submit-btn">
          {t('registerCustomer.register')}
        </button>
      </form>

      {token && (
        <div className="mt-4 text-center">
          <p>
            {t('registerCustomer.generatedLink')}:
            <code className="block mt-2">
              {`${window.location.origin}/customer-clinic/${token}`}
            </code>
          </p>
          <button
            onClick={() => {
              navigator.clipboard.writeText(`${window.location.origin}/customer-clinic/${token}`);
              alert(t('registerCustomer.linkCopied'));
            }}
            className="clinic-action-btn mt-2"
          >
            📋 {t('registerCustomer.copyLink')}
          </button>
          
        </div>
      )}
    </div>
  );
};

export default RegisterCustomer;
